import { useRef } from 'react';

import { nanoid } from 'nanoid';

const useRandomId = (id?: string) => {
  const idRef = useRef<string | undefined>(id);

  if (!idRef.current) {
    idRef.current = nanoid();
  }

  return idRef.current;
};

export default useRandomId;
